const isDev = process.env.NODE_ENV === "development";
const isDebug =
  typeof window !== "undefined" &&
  (window.localStorage.getItem("topleader_debug") === "true" ||
    window.topleader_debug === true);

export const Logger = {
  log: (...args) => {
    if (isDev || isDebug) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (isDev || isDebug) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    // Always log errors, or maybe gate them too? Usually errors should be seen.
    console.error(...args);
  },
  // Alias for debug
  debug: (...args) => {
    if (isDev || isDebug) {
      console.debug(...args);
    }
  },
};
